import React from 'react';
import { CheckoutSummaryPriceDetails } from 'components/views/pages/Checkout/CheckoutSummary/components/CheckoutSummaryPriceDetails';
import { CheckoutSummaryFooter } from 'components/views/pages/Checkout/CheckoutSummary/components/CheckoutSummaryFooter';
import { CheckoutStepProps } from 'pages/[propertyId]/reservenow';
import { SummaryLayout } from 'components/views/pages/Checkout/CheckoutSummary/SummaryLayout';

interface Props {
  isLastStep: boolean;
}

export const CheckoutSummary = ({
  checkoutData,
  paymentType,
  isLastStep,
  bookingData,
  currency_code,
  currency_multiplier,
  pid,
}: Pick<CheckoutStepProps, 'checkoutData' | 'paymentType' | 'bookingData' | 'pid' | 'currency_code' | 'currency_multiplier'> & Props) => {
  return (
    <SummaryLayout pid={pid}>
      <CheckoutSummaryPriceDetails
        checkoutData={checkoutData}
        bookingData={bookingData}
        isLastStep={isLastStep}
        currency_code={currency_code}
        currency_multiplier={currency_multiplier}
      />
      <CheckoutSummaryFooter
        paymentType={paymentType}
        checkoutData={checkoutData}
        isLastStep={isLastStep}
        bookingData={bookingData}
      />
    </SummaryLayout>
  );
};
